export default function LegalPage({ content, testId }) {
  return (
    <main data-testid={testId} className="relative pt-32 md:pt-40 pb-32" style={{ fontVariantLigatures: "none", fontFeatureSettings: '"calt" 0, "liga" 0, "dlig" 0' }}>
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <p className="text-[11px] tracking-[0.3em] uppercase text-gold mb-8">{content.eyebrow}</p>
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-bone tracking-tight leading-[1.05]" data-testid={`${testId}-heading`}>
          {content.heading}
        </h1>
        <p className="mt-6 text-xs tracking-[0.2em] uppercase text-fog" data-testid={`${testId}-effective`}>{content.effective}</p>
        <div className="gold-rule my-12" />
        <div className="space-y-10">
          {content.sections.map((s, i) => (
            <section key={i} data-testid={`${testId}-section-${i + 1}`}>
              <h2 className="font-serif text-xl md:text-2xl text-bone tracking-tight">{s.title}</h2>
              <p className="mt-3 text-bone/75 font-light leading-[1.85] text-sm md:text-base whitespace-pre-line">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
